<wiz-vgroup #vgEdition wizValidationContainer
  width="100%" height="100%" gap="2" class="section-container">

  <wiz-dropdown
        #ddState
        width="120px"
        [wizLabelField]="'trsLabel'"
        [wizLabel]="'$.wf.state.$'"
  ></wiz-dropdown>
  
  <wiz-hgroup wizValidationContainer width="100%">

    <wiz-datefield #daStart [wizLabel]="'$.wf.startdate.$'"></wiz-datefield>
    <wiz-datefield #daEnd [wizLabel]="'$.wf.enddate.$'"></wiz-datefield>

  </wiz-hgroup>


  <wiz-text-area #taContent wizShowLabel="false"
    width="100%" height="140px" wizValidator
    [wizMaxChars]="2000"></wiz-text-area>   

  <wiz-hgroup width="100%" gap="2" horizontalAlign="end" verticalAlign="center">

    <wiz-button
        #btnCancel
        (wizClick)="cancel()"
        class="cancel-button"
        [wizIcon]="'icon-arrow-left'"
        [wizLabel]="'$.common.cancel.modification.$'"
    ></wiz-button>

    <wiz-button
      #btnSave
      [wizLabel]="'$.common.save.$'"
      [wizIcon]="'icon-arrow-right'"
      (click)="save()"
      [iconPlacement]="'right'"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
